import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#arbitrary-time-range" }),
  /*#__PURE__*/_createTextVNode(" Arbitrary time range ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Can pick an arbitrary time range. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_time_picker = _resolveComponent("el-time-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_time_picker, {
        style: {"margin-right":"5px"},
        "is-range": "",
        modelValue: _ctx.value1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
        "range-separator": "To",
        "start-placeholder": "Start time",
        "end-placeholder": "End time"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_time_picker, {
        "is-range": "",
        "arrow-control": "",
        modelValue: _ctx.value2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
        "range-separator": "To",
        "start-placeholder": "Start time",
        "end-placeholder": "End time"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}